
import Vue from "vue";
import Component from "vue-class-component";
import RulesUtil from "@/util/rules";
import LoginModel from "@/models/login.model";
import AutenticacaoService from "@/service/autenticacao.service";

@Component({
  name: "Login"
})
export default class Login extends Vue {

  rules = RulesUtil;
  showPassword = false;
  login = new LoginModel();

  async entrar() {
    if ((this.$refs.formLogin as HTMLFormElement).validate()) {
      await AutenticacaoService.login(this.login, this);
    }
  }
}
